import { noop } from '../utils/utils';
const listeners = {};
function callEach(functions, data) {
  functions.forEach(function (currentFunction) {
    currentFunction(data);
  });
}
function callEachAtIndex(functions, index, data) {
  functions.forEach(function (functions) {
    functions[index](data);
  });
}
function emitWithArrayOfPromises(eventTarget, eventName, params) {
  // no listeners
  if (typeof listeners[eventName] === 'undefined') {
    return {
      resolveAt: noop,
      rejectAt: noop
    };
  }
  const resolvers = [];
  const rejectors = [];
  listeners[eventName].forEach(function (listener) {
    const thisEventResolvers = [];
    const thisEventRejectors = [];
    const eventPromises = params.promises.map(function () {
      return new Promise(function (resolve, reject) {
        thisEventResolvers.push(resolve);
        thisEventRejectors.push(reject);
      });
    });
    resolvers.push(thisEventResolvers);
    rejectors.push(thisEventRejectors);
    listener(eventPromises, params);
  });
  return {
    resolveAt(index, data) {
      callEachAtIndex(resolvers, index, data);
    },
    rejectAt(index, data) {
      callEachAtIndex(rejectors, index, data);
    }
  };
}
export function emit(eventTarget, eventName, params) {
  if (typeof eventTarget !== 'object' || eventTarget === null) {
    throw new Error('target should be a function');
  }
  if (typeof eventName !== 'string') {
    throw new Error('eventName should be a string');
  }
  params = params || {};
  params.eventTarget = eventTarget;
  params.eventName = eventName;
  if (params.promises && params.promises.length) {
    return emitWithArrayOfPromises(eventTarget, eventName, params);
  }

  // no listeners
  if (typeof listeners[eventName] === 'undefined') {
    return {
      resolve: noop,
      reject: noop
    };
  }
  const resolvers = [];
  const rejectors = [];
  listeners[eventName].forEach(function (listener) {
    const promise = new Promise(function (resolveCurrent, rejectCurrent) {
      resolvers.push(resolveCurrent);
      rejectors.push(rejectCurrent);
    });
    listener(promise, params);
  });
  return {
    resolve(data) {
      callEach(resolvers, data);
    },
    reject(reason) {
      callEach(rejectors, reason);
    }
  };
}
export function emitResolve(eventTarget, eventName, params, result) {
  const promise = Promise.resolve(result);
  params.promises = [promise];
  const event = emit(eventTarget, eventName, params);
  promise.then(function (data) {
    event.resolveAt(0, data);
  });
  return event;
}

/**
 * @summary Subscribe listener to event
 * @name on
 * @memberof mediaManagerSDK.events
 * @method
 * @param eventName {String} Event name
 * @param listener {Function} Callback function that is when corresponding method is fired
 */
export function addListener(eventName, listener) {
  if (typeof listeners[eventName] === 'undefined') {
    listeners[eventName] = [];
  }
  listeners[eventName].push(listener);
}

/**
 * @summary Unsubscribe listener from event
 * @name off
 * @memberof mediaManagerSDK.events
 * @method
 * @param eventName {String} Event name
 * @param listener {Function} Callback function
 */
export function removeListener(eventName, listener) {
  if (listeners[eventName]) {
    const index = listeners[eventName].indexOf(listener);
    listeners[eventName].splice(index, 1);
  }
}